import {
  DeliveredBatchesQueryDTO,
  PagedDeliveredBatchesDTO,
  DeliveredBatchDTO,
  DeliveredTasksStatsDTO,
  DeliveredTaskDTO,
  DeliveryExportDTO,
} from '@scale/shared/ots/dto';
import { CustomerDTO } from '@scale/shared/chatDeliveryBuilder';
import apiFetch from '@scale/frontend-lib/api-fetch';
import { DataStreamDeliveryDTO } from '@scale/customer-app-shared';

export async function fetchBatches(query: DeliveredBatchesQueryDTO) {
  const res = await apiFetch<PagedDeliveredBatchesDTO>(null, `corp-api/ots-utils-v2/batches`, {
    query,
    method: 'GET',
  });
  return res;
}

export async function fetchBatch(batchId: string) {
  const res = await apiFetch<DeliveredBatchDTO>(null, `corp-api/ots-utils-v2/batch/${batchId}`, {
    method: 'GET',
  });
  return res;
}

export async function fetchBatchStats(batchId: string) {
  const res = await apiFetch<DeliveredTasksStatsDTO>(
    null,
    `corp-api/ots-utils-v2/batch/${batchId}/tasksStats`,
    {
      method: 'GET',
    },
  );
  return res;
}

export async function fetchBatchTasks(batchId: string) {
  const res = await apiFetch<DeliveredTaskDTO[]>(
    null,
    `corp-api/ots-utils-v2/batch/${batchId}/tasks`,
    {
      method: 'GET',
    },
  );
  return res;
}

export async function deliverBatch(batchId: string) {
  const res = await apiFetch<DeliveredBatchDTO>(
    null,
    `corp-api/ots-utils-v2/batch/${batchId}/deliver`,
    {
      method: 'post',
    },
  );
  return res;
}

export async function cancelBatch(batchId: string) {
  const res = await apiFetch<DeliveredBatchDTO>(
    null,
    `corp-api/ots-utils-v2/batch/${batchId}/cancel`,
    {
      method: 'post',
    },
  );
  return res;
}

export async function acceptBatch(batchId: string, acceptedAt: Date) {
  const res = await apiFetch<{}>(null, `corp-api/ots-utils-v2/batch/${batchId}/accept`, {
    method: 'post',
    body: { acceptedAt },
  });
  return res;
}

export async function acceptBatchTasks(batchId: string, taskIds: string[], acceptedAt: Date) {
  const res = await apiFetch<{}>(null, `corp-api/ots-utils-v2/batch/${batchId}/acceptTasks`, {
    method: 'post',
    body: { taskIds, acceptedAt },
  });
  return res;
}

export async function exportBatches(batchIds: string[]) {
  const res = await apiFetch<DeliveryExportDTO>(null, `corp-api/ots-utils-v2/export/batches`, {
    method: 'POST',
    body: { batchIds },
  });
  return res;
}

export async function getBatchFollowers(batchId: string) {
  const res = await apiFetch<{ followers: CustomerDTO[] }>(
    null,
    `corp-api/ots-utils-v2/batch/${batchId}/followers`,
    {
      method: 'GET',
    },
  );
  return res;
}

export async function getDataStreamInfo(batchId: string) {
  const res = await apiFetch<DataStreamDeliveryDTO>(
    null,
    `corp-api/ots-utils-v2/batch/${batchId}/dataStreamInfo`,
    {
      method: 'GET',
    },
  );
  return res;
}
